import { render } from "./WalletSection.vue?vue&type=template&id=66952d14&ts=true"
import script from "./WalletSection.vue?vue&type=script&lang=ts"
export * from "./WalletSection.vue?vue&type=script&lang=ts"

import exportComponent from "/var/www/logiplanner_web_prod/logiplanner_web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__